<template>
  <el-dialog
    :visible.sync="isShowDialog" class="dialog-square"
    :title="$t('item.stockError')" center width="520px"
    :close-on-click-modal="true" @close="whenDialogClose">

    <div class="mydialog df-l-c-fs">
      <slot name="header"></slot>
      <div class="w100p f1">
        <div class="text f-s _redcolor w100p" v-for="(x,i) in messages" :key="i">{{x['text'+_lang]}}</div>
      </div>
      <slot name="footer"></slot>
      <div class="dialog-btm w100p df-c-sa">
        <div class="themebtn" @click="submit">{{$t('common.comfirm')}}</div>
      </div>
    </div>

  </el-dialog>
</template>

<script>
export default {
  name: 'DialogError',
  props: ['messages'],
  data() {
    return {
      isShowDialog: false,
    }
  },
  methods: {
    open() {
      this.scan_canLeave_x_save(false)
      this.isShowDialog = true
    },
    close() {
      this.isShowDialog = false
    },
    whenDialogClose() {
      this.$emit('close')
      this.scan_canLeave_x_save(true)
      this.isShowDialog = false
    },
    submit() {
      this.$emit('submit')
      this.close()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/util_dialog.scss';
.mydialog{
  padding: 30px 60px;min-height: 380px;
  .text{min-height: 40px;line-height: 28px;padding: 6px 0;word-break: keep-all;}
}
</style>